import axios from "axios";

export function getComentarios() {
  return axios.get('/api/comentarios');
}